import { environment } from '../../../../environments/environment';

/**
 * Base URL of the API gateway that fronts Auth M. Everything in this package
 * goes through the gateway — never to a service directly. Sourced from the
 * app environment (`authMUrl`) so it differs per build (local → the local
 * gateway, deployed → https://<host>/api). Falls back to the local gateway.
 *
 * This is the ONLY app-coupled file in the auth-m package; when this folder is
 * extracted into its own library, replace this with an injected config token.
 */
export const GATEWAY_URL: string =
  (environment as { authMUrl?: string }).authMUrl ?? 'http://localhost:8080';

/**
 * Shows the dev helpers (auto-fill OTP / open emailed links from Auth M's dev
 * mailbox). They only work when Auth M runs with DEV_MODE=true and the gateway
 * exposes /dev. Off unless `authMDevHelpers` is set in the environment.
 */
export const DEV_HELPERS: boolean =
  (environment as { authMDevHelpers?: boolean }).authMDevHelpers ?? false;
